import { msg } from 'gt-react';

/**
 * Display text for the sidebar's code-defined section titles.
 *
 * A section title cannot become a translatable field the way a nav label did,
 * because `nav.group` doubles as the section's *identity*: `groupNavEntries`
 * uses it as the group id that collapse state is keyed by, and
 * `reconcileNavLayout` matches a persisted `section.title` against it to decide
 * where a newly shipped route lands. Encoding it with `msg()` would change that
 * id and silently orphan every saved sidebar layout. So the raw string stays the
 * id, and this map supplies its display text keyed by that id.
 *
 * Values are `msg()`-encoded, so consumers must decode them — see
 * `useRouteMessage()` in `@/routing/route-messages`. A title that is absent here
 * renders verbatim, which is the right answer for a section the user renamed in
 * navigation settings: those are their words, not ours.
 *
 * Keep this in step with the `group:` values declared in route metadata; a
 * missing entry is not an error, it just leaves that header untranslated.
 */
export const NAV_GROUP_TITLES: Record<string, string> = {
  'Accounts Payable': msg('Accounts Payable', {
    context: 'sidebar section title',
  }),
  'Accounts Receivable': msg('Accounts Receivable', {
    context: 'sidebar section title',
  }),
  Admin: msg('Admin', { context: 'sidebar section title' }),
  Assistant: msg('Assistant', { context: 'sidebar section title' }),
  'Inventory Management': msg('Inventory Management', {
    context: 'sidebar section title',
  }),
  'Item Master': msg('Item Master', { context: 'sidebar section title' }),
  Organization: msg('Organization', { context: 'sidebar section title' }),
  Other: msg('Other', {
    context: 'sidebar section title for routes declaring no section',
  }),
  Overview: msg('Overview', { context: 'sidebar section title' }),
  Pricing: msg('Pricing', { context: 'sidebar section title' }),
  Procurement: msg('Procurement', { context: 'sidebar section title' }),
  Rebates: msg('Rebates', { context: 'sidebar section title' }),
  Sales: msg('Sales', { context: 'sidebar section title' }),
  'Ship and Debit': msg('Ship and Debit', {
    context: 'sidebar section title',
  }),
  'Ship and Debit Admin': msg('Ship and Debit Admin', {
    context: 'sidebar section title',
  }),
};
